import {Component, Input, OnInit} from '@angular/core';
import {Events} from "../../../../framework/providers/events";
import {AdminService} from "../../../../core/services/AdminService";
import {ModelProvider} from "../../../../framework/providers/modelProvider/ModelProvider";
import {ModelToolsProvider} from "../../../../framework/providers/model-tools/model-tools";
import {AppConfig} from 'src/core/conf/main';

@Component({
    selector: 'app-quick-filter',
    templateUrl: './app-quick-filter.component.html',
    styleUrls: ['./app-quick-filter.component.scss'],
})
export class AppQuickFilterComponent implements OnInit {

    @Input()
    sectionName;
    @Input()
    prefix;
    @Input()
    baseFilter = {};
    @Input()
    exTableData;

    quickAddModel;
    fieldTypes;
    advancedFilters;
    advancedFiltersByName;
    tableData;
    activeTab;
    modelFields;

    //if select custom filter
    selectedFilter;

    public AppConfig = AppConfig;

    constructor(public events: Events,
                public modelTools: ModelToolsProvider,
                public adminService: AdminService, public modelProvider: ModelProvider) {
    }

    ngOnInit() {
        this.quickAddModel = this.adminService.getNewModel(this.sectionName, this.exTableData);
        this.fieldTypes = this.adminService.getFieldsType(this.sectionName, this.exTableData);

        this.modelFields = this.exTableData[this.sectionName + 'ModelFields'];
        // console.log(this.modelFields);
        this.tableData = this.exTableData[this.sectionName + 'Data'];
        this.loadFilters();
    }


    loadFilters() {
        let filters = this.adminService.getMainFilters();
        filters['getModelSelectTableOptions'] = this.sectionName;
        filters['baseFilter'] = JSON.stringify(this.baseFilter ? this.baseFilter : {});
        let me = this;

        this.modelProvider.list('report', filters)
            .then(function (data: any) {
                me.advancedFilters = data['models'][0].data['finalResReport']['advancedFilters']['filters'];
                let defaults = data['models'][0].data['finalResReport']['advancedFilters']['defaults'];
                // console.log(me.advancedFilters);
                me.advancedFiltersByName = {};
                for (let filter of me.advancedFilters) {


                    me.advancedFiltersByName[filter.name] = filter;
                }

                //set defaults
                //get from server
                for (let field of me.modelFields) {
                    if (defaults[field.name['value']]) {
                        let filter = me.advancedFiltersByName[field.name['value']];
                        if (['selectOptionFull', 'selectOptions'].includes(me.fieldTypes[field['name']['value']].type)) {
                            field['options'] = [defaults[field.name['value']]];
                        } else if (['selectTable'].includes(me.fieldTypes[field['name']['value']].type)) {
                            for (let fkey in filter.data) {
                                if (filter.data[fkey]['id']['value'] == defaults[field.name['value']]) {
                                    filter.data[fkey]['chosen'] = true;
                                }
                            }


                        } else {

                        }
                    }

                    if (me.fieldTypes[field['name']['value']] && ['selectTable'].includes(me.fieldTypes[field['name']['value']].type)) {
                        field['options'] = [];
                    }
                }

            });
    }

    clearFilter() {
        this.loadFilters();
        this.modelFields = this.exTableData[this.sectionName + 'ModelFields'];
        this.events.publish("btnclick_" + this.prefix, {
            'key': 'addFilter',
            'data': {'fieldFilters': {}}
        });
    }

    addFilter() {
        let me = this;
        let inputs = [
            {
                name: 'name',
                type: 'text',
                label: 'Please enter a filter name:'
            }
        ];
        this.modelTools.inputAlert('Custom Var', 'Please enter name of custom field', function (res) {
            console.log(res);
            me.buttonClick({'addFilter': res['name']});
        }, false, inputs);
    }


    showFilterFields() {
        this.presentSelectBar(null, 'columns', true);
    }

    buttonClick(filters = {}) {
        console.log('click!');

        if (this.selectedFilter) {
            this.filterit({'filterId': this.selectedFilter['id']['value']});
            return;
        }

        for (let field of this.modelFields) {
            if (!field['canFilter']['value']) continue;
            let fieldName = field['name']['value'];
            let type = this.fieldTypes[field['name']['value']].type;

            if (['selectOptionFull', 'selectOptions'].includes(type)) {
                filters[fieldName] = {'options': field['options'] ? field['options'] : [], 'type': type}
            } else if (type == 'selectTable') {
                // filters = field['options'];
                // let adv = this.advancedFiltersByName[field['name']['value']];
                // if (field['options']) {
                //     for (let item of adv['data']) {
                //         console.log(item['id']['value']);
                //         if (field['options'].includes(item['id']['value'])) {
                //             console.log(item['main']['displayName']);
                //             filter.push(item['id']['value']);
                //         }
                //     }
                // }
                if (field['options'] && field['options'].length > 0) {
                    filters[fieldName] = {'options': field['options'], 'type': type};
                }
            } else if (['text', 'textarea'].includes(type)) {
                console.log(field['value']);
                filters[fieldName] = {'options': field['value'], 'type': type};

            } else if (['number', 'float'].includes(type)) {
                filters[fieldName] = {
                    'value': field['value'],
                    'betweenValue': field['betweenValue'],
                    'op': field['op'],
                    'type': type
                };

            } else if (['date', 'datetime'].includes(type)) {
                console.log('datetime:');
                console.log(field['start']);
                console.log(field['end']);
                filters[fieldName] = {
                    'start': field['start'],
                    'end': field['end'],
                    'chooseType': field['chooseType'],
                    'type': type
                };
            } else if (type == 'time') {
                filters[fieldName] = {
                    'start': field['start'],
                    'end': field['end'],
                    'chooseType': field['chooseType'],
                    'type': type
                };
            } else if (type == 'boolean') {
                console.log('boolean:');
                console.log(field['true']);
                console.log(field['false']);

                filters[fieldName] = {'value': field['value'], 'type': 'boolean'};
            }
        }

        console.log(filters);
        this.filterit(filters);
    }

    filterit(filters) {
        this.events.publish("btnclick_" + this.prefix, {
            'key': 'addFilter',
            'data': {'fieldFilters': filters}
        });
    }

    addSelectTableOption(field, item, items) {
        console.log(this.fieldTypes[field['name']['value']]);
        if (this.fieldTypes[field['name']['value']]['filterSingle']) {
            for (let item of items) {
                item['chosen'] = false;
            }
        }
        item['chosen'] = !!!item['chosen'];
        this.buttonClick();
    }

    addSelectOption(field, optionId) {
        if (this.fieldTypes[field['name']['value']]['filterSingle']) {
            field['options'] = [];
        }

        if (!field['options']) field['options'] = [];
        if (field['options'].indexOf(optionId) != -1) {
            field['options'].splice(field['options'].indexOf(optionId), 1);
        } else {
            field['options'].push(optionId);
        }
    }

    async presentSelectBar(myEvent, type, bigPopup = false) {
        this.adminService.popupEditBoxByData(null, {
            'prefix': this.prefix,
            'exTableData': this.exTableData,
            'sectionName': this.sectionName,
            'type': type
        }, bigPopup);
    }

    fieldSelect(field) {
        console.log('field select!!!')
        console.log(field)
        field['open'] = true;
    }
}
